import { PlayerService } from "../services/PlayerService";

type CheckCodeResponse = {
    correctCode: boolean;
};

export class KeyPadService {
    public async checkCode(type: string, code: string): Promise<boolean> {
        const response: Response = await fetch(`${VITE_API_URL}keypad/${type}/${code}`,
            {
                method: "GET",
                headers: {
                    "X-PlayerSessionId": new PlayerService().getPlayerSessionId(),

                },
            });
        const data: CheckCodeResponse = await response.json() as CheckCodeResponse;

        return data.correctCode;
    }
}
